import { render, staticRenderFns } from "./FaizTuruForm.vue?vue&type=template&id=aeedf8e6"
import script from "./FaizTuruForm.vue?vue&type=script&lang=ts"
export * from "./FaizTuruForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports